import CardTermsBlock from './CardTermsBlock';

export default CardTermsBlock;
